import React, { useContext } from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';
import StoreContext from '../../../react-core-lib/components/app/store-context';
import { landingPageUrl } from '../../../config';

const Copyright = ({ clinicData }) => {
    const theme = useTheme();
    const { userDataStore } = useContext(StoreContext);
    const userData = userDataStore?.userData || {};
    const subscriptionData = userDataStore?.subscriptionData || {};

    // Will use propClinicData (from Viewer) if available, otherwise Platform context
    const resolvedClinicData = clinicData?.clinicData?.clinicName
        ? { ...clinicData.clinicData, source: 'partner' }
        : {
              clinicName: userData.clinicName || '',
              url: userData.clinicImageId || '',
              emailAddress: userData.emailAddress || '',
              clinicNumber: userData.clinicNumber || '',
              accountType: subscriptionData.accountType || '',
              showLogo: userData.showLogoInHandouts || false,
              source: 'platform',
          };

    // same variable like in Patient UI
    const isPartner = resolvedClinicData.source === 'partner';
    const hasLogo = isPartner
        ? !!resolvedClinicData.url
        : resolvedClinicData.showLogo === true && !!resolvedClinicData.url;
    const hasContactInfo = !!resolvedClinicData.emailAddress || !!resolvedClinicData?.clinicNumber;
    const showContactBlock = isPartner && hasContactInfo;
    const showClinicNameFallback =
        resolvedClinicData.clinicName && !hasLogo && resolvedClinicData.source === 'platform';

    return (
        <>
            {/* Partner contact block */}
            {showContactBlock && (
                <Box
                    component="footer-top"
                    sx={{
                        mb: 3,
                        fontSize: 16,
                        '@media print': { display: 'none' },
                    }}
                >
                    <Typography variant="body2" mb={3}>
                        {resolvedClinicData?.clinicName && (
                            <>
                                For any queries related to <strong>{resolvedClinicData.clinicName}</strong>,{' '}
                            </>
                        )}
                        please feel free to contact us via{' '}
                        {resolvedClinicData?.emailAddress && (
                            <>
                                email:{' '}
                                <Link href={`mailto:${resolvedClinicData.emailAddress}`} underline="always">
                                    {resolvedClinicData.emailAddress}
                                </Link>
                                {resolvedClinicData?.clinicNumber && ' or '}
                            </>
                        )}
                        {resolvedClinicData?.clinicNumber && <>phone: {resolvedClinicData.clinicNumber}</>}.
                    </Typography>
                </Box>
            )}

            {/* Always show footer */}
            <Box
                component="footer"
                sx={{
                    pt: 1,
                    textAlign: 'left',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    '@media print': {
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        bgcolor: 'background.paper',
                        zIndex: 0,
                        overflow: 'visible',
                        py: 0,
                        display: 'none',
                    },
                }}
            >
                <Typography
                    variant="caption"
                    sx={{ lineHeight: '1.5', fontSize: 16, '@media print': { fontSize: '6pt', marginBottom: '-9px' } }}
                >
                    © Copyright Cetra Health.{' '}
                    <Box sx={{ '@media (min-width: 600px)': { display: 'inline-block' } }}>All rights reserved.</Box>
                    <br />
                    <Link
                        href={landingPageUrl}
                        color="inherit"
                        underline="always"
                        sx={{
                            '@media print': {
                                textDecoration: 'none',
                                lineHeight: '1',
                                display: 'block',
                                marginTop: '-3px',
                            },
                        }}
                        target="_blank"
                        rel="noopener"
                    >
                        {landingPageUrl}
                    </Link>
                </Typography>

                {/* Show logo or clinic name fallback */}
                {resolvedClinicData && (
                    <>
                        {isPartner ? (
                            // Viewer: always show logo if available
                            hasLogo && (
                                <img
                                    src={resolvedClinicData.url}
                                    alt="Clinic Logo"
                                    style={{
                                        position: 'absolute',
                                        right: 10,
                                        bottom: 2,
                                        height: 75,
                                        marginTop: 0,
                                    }}
                                />
                            )
                        ) : (
                            // Platform: conditional display based on user settings
                            <>
                                {resolvedClinicData.showLogo && resolvedClinicData.url && (
                                    <img
                                        src={resolvedClinicData.url}
                                        alt="Clinic Logo"
                                        style={{
                                            position: 'absolute',
                                            right: 10,
                                            bottom: 2,
                                            height: 75,
                                            marginTop: 0,
                                        }}
                                    />
                                )}
                                {resolvedClinicData.showLogo &&
                                    !resolvedClinicData.url &&
                                    resolvedClinicData.clinicName && (
                                        <Box sx={{ position: 'absolute', right: 10, bottom: 2, fontSize: 16 }}>
                                            {resolvedClinicData.clinicName}
                                        </Box>
                                    )}
                            </>
                        )}
                    </>
                )}
            </Box>
        </>
    );
};

export default Copyright;
